import addRoute from '@/router/add-route';

const Settings = () => import('@/modules/profile/profile.vue');

const profile = [
    addRoute({
        name: 'profile',
        path: '/profile',
        component: Settings,
    }),
];

export default profile;
